import { BASE_URL } from "@services/api";
import axios from "axios";
import { useConfig } from "../../axiosInstance";

export const axiosInstanceCustomers = axios.create({
  baseURL: `${BASE_URL}/front-bg`,
});

axiosInstanceCustomers.interceptors.request.use(useConfig);
